// import ENV from './utils/env';

// export const IS_PRODUCTION = ENV.NODE_ENV.toUpperCase() === 'PRODUCTION';
// export const LOG_ROCKET_ID = IS_PRODUCTION ? ENV.LOG_ROCKET_PRODUCTION : ENV.LOG_ROCKET_STAGING;
// export const API_VERSION = process.env.REACT_APP_API_VERSION;
export const PAGINATION_PAGE_SIZE = parseInt(process.env.REACT_APP_PAGINATION_PAGE_SIZE ?? '10', 10);

export const Country = {
  Thailand: '1',
};

export const Theme = {
  Select: 1,
  Diversified: 3,
  Assure: 4,
  Motor: 5,
};

export const RepaymentType = {
  BulletRepayment: 'Bullet Repayment',
  InstalmentRepayment: 'Instalment Repayment',
};

export const TransactionType = {
  InvestmentAllocation: 'Investment Allocation',
  Invest: 'Invest',
  Withdrawal: 'Withdrawal',
  ProfitReturned: 'Profit Returned',
  ServiceFees: 'Service Fees',
  PrincipalReturned: 'PrincipalReturned',
  Other: 'Other',
  MM: 'MM',
  ECF: 'ECF',
  ReferralReward: 'Referral Reward',
};

export const UpdatePortfolioAction = {
  select: 'select',
  unselect: 'unselect',
  update: 'update',
};

export const BootstrapBreakpoints = {
  SM: 576,
  MD: 768,
  LG: 992,
  XL: 1200,
};

export const WithdrawReason = {
  Other: 8,
};

export const Colors = {
  red: '#ff4861',
  primary: '#226ef4',
};

export const CapBayBoolean = {
  True: '1',
  False: '0',
};

export const InvestmentNoteLaunchStatus = {
  Active: 1,
  PendingReview: 2,
  PendingAllocation: 3,
  Allocated: 4,
  PendingApproval: 5,
  Completed: 6,
};

export const KnowledgeTestQuestionOptions = {
  YES: 1,
  NO: 2,
};

export const InvestorCategory = {
  Retail: 1,
  HNWI: 2,
  HNWE: 3,
  Institutional: 4,
};

export const NetWorthRange = {
  Below2M: 1,
  Range2M_5M: 2,
  Range5M_7_5M: 3,
  Range7_5M_10M: 4,
  Range10M_15M: 5,
  Range15M_30M: 6,
  Range30M_60M: 7,
  Above60M: 8,
};

export const AnnualIncomeRange = {
  Below500K: 1,
  Range500K_1_5M: 2,
  Range1_5M_3M: 3,
  Range3M_5M: 4,
  Range5M_6M: 5,
  Range6M_8M: 6,
  Above8M: 7,
};

export const InvestorCategoryThresholds = {
  NET_WORTH_MIN_VALUE: NetWorthRange.Range30M_60M,
  ANNUAL_INCOME_MIN_VALUE: AnnualIncomeRange.Range3M_5M,
};
